import React from 'react';
import UnauthorizedLayout from 'features/shared/layouts/unauthorized';
import ExpertOpinion from 'features/expertOpinion';

const ExpertOpinionPage = () => (
  <UnauthorizedLayout>
    <ExpertOpinion />
  </UnauthorizedLayout>
);

export default ExpertOpinionPage;
